var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrackpadInput(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1008_21265",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.000976562,
    width: 24,
    height: 24,
    fill: "#7A1600"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1008_21265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18.999C3.45 18.999 2.97917 18.8032 2.5875 18.4115C2.19583 18.0199 2 17.549 2 16.999V4.99902C2 4.44902 2.19583 3.97819 2.5875 3.58652C2.97917 3.19486 3.45 2.99902 4 2.99902H19C19.55 2.99902 20.0208 3.19486 20.4125 3.58652C20.8042 3.97819 21 4.44902 21 4.99902V8.99902H19V4.99902H4V16.999H5.8L7.775 18.999H4ZM14.825 21.999C14.425 21.999 14.0417 21.924 13.675 21.774C13.3083 21.624 12.9833 21.4074 12.7 21.124L7.6 15.999L8.425 15.149C8.65833 14.9157 8.94167 14.7574 9.275 14.674C9.60833 14.5907 9.94167 14.5907 10.275 14.674L12 15.174V7.99902C12 7.71569 12.0958 7.47819 12.2875 7.28652C12.4792 7.09486 12.7167 6.99902 13 6.99902C13.2833 6.99902 13.5208 7.09486 13.7125 7.28652C13.9042 7.47819 14 7.71569 14 7.99902V13.999H15V10.999C15 10.7157 15.0958 10.4782 15.2875 10.2865C15.4792 10.0949 15.7167 9.99902 16 9.99902C16.2833 9.99902 16.5208 10.0949 16.7125 10.2865C16.9042 10.4782 17 10.7157 17 10.999V13.999H18V11.999C18 11.7157 18.0958 11.4782 18.2875 11.2865C18.4792 11.0949 18.7167 10.999 19 10.999C19.2833 10.999 19.5208 11.0949 19.7125 11.2865C19.9042 11.4782 20 11.7157 20 11.999V13.999H21C21 13.7157 21.0958 13.4782 21.2875 13.2865C21.4792 13.0949 21.7167 12.999 22 12.999C22.2833 12.999 22.5208 13.0949 22.7125 13.2865C22.9042 13.4782 23 13.7157 23 13.999V17.999C23 19.099 22.6083 20.0407 21.825 20.824C21.0417 21.6074 20.1 21.999 19 21.999H14.825Z",
    fill: "#7A1600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackpadInput);
export default __webpack_public_path__ + "static/media/trackpad_input.06d2cbff141537c073a9fa140c581060.svg";
export { ForwardRef as ReactComponent };